var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.changed_new_cost
      ? _c("table", { staticClass: "table" }, [
          _c(
            "tbody",
            _vm._l(_vm.changed_new_cost, function(new_cost) {
              return _c(
                "div",
                {
                  key: new_cost.manufacturer.id,
                  staticStyle: { "margin-top": "10px" }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "cust-button",
                      on: {
                        click: function($event) {
                          return _vm.toggle(new_cost["manufacturer"]["id"])
                        }
                      }
                    },
                    [
                      _vm._v(
                        "toggle " + _vm._s(new_cost["manufacturer"]["name"])
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show(new_cost["manufacturer"]["id"]),
                          expression: "show(new_cost['manufacturer']['id'])"
                        }
                      ]
                    },
                    [
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticStyle: { cursor: "pointer" },
                            attrs: { width: "40%" }
                          },
                          [
                            _c("h5", [
                              _vm._v(
                                _vm._s(new_cost["manufacturer"]["name"]) +
                                  " (" +
                                  _vm._s(new_cost["manufacturer"]["id"]) +
                                  ")"
                              )
                            ]),
                            _vm._v(" "),
                            _c("h3", [
                              _vm._v(
                                _vm._s(new_cost["model"]) +
                                  " (" +
                                  _vm._s(
                                    new_cost["printer"]
                                      ? new_cost["printer"]["id"]
                                      : null
                                  ) +
                                  ")"
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm._m(0, true),
                        _vm._v(" "),
                        _vm._m(1, true),
                        _vm._v(" "),
                        _vm._m(2, true),
                        _vm._v(" "),
                        _vm._m(3, true),
                        _vm._v(" "),
                        _vm._m(4, true),
                        _vm._v(" "),
                        _vm._m(5, true),
                        _vm._v(" "),
                        _vm._m(6, true)
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [
                          _c("b", [_vm._v("C16 " + _vm._s(_vm.letter))]),
                          _vm._v(" Kits cost")
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["kit_cost"] ? new_cost["kit_cost"] : 0
                              ) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(7, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["service_cost"]["purchase"]) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L1")]),
                          _vm._v(
                            " £" + _vm._s(new_cost["service_cost"]["lease"][0])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L2")]),
                          _vm._v(
                            " £" + _vm._s(new_cost["service_cost"]["lease"][1])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L3")]),
                          _vm._v(
                            " £" + _vm._s(new_cost["service_cost"]["lease"][2])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L4")]),
                          _vm._v(
                            " £" + _vm._s(new_cost["service_cost"]["lease"][3])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L5")]),
                          _vm._v(
                            " £" + _vm._s(new_cost["service_cost"]["lease"][4])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L6")]),
                          _vm._v(
                            " £" + _vm._s(new_cost["service_cost"]["lease"][5])
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [_vm._v("Annual incremental Service Cost")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_service_cost"][
                                  "purchase"
                                ]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_service_cost"][
                                  "lease"
                                ][0]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_service_cost"][
                                  "lease"
                                ][1]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_service_cost"][
                                  "lease"
                                ][2]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_service_cost"][
                                  "lease"
                                ][3]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_service_cost"][
                                  "lease"
                                ][4]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_service_cost"][
                                  "lease"
                                ][5]
                              )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(8, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["settlement_cost"]["purchase"]) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["settlement_cost"]["lease"][0])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["settlement_cost"]["lease"][1])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["settlement_cost"]["lease"][2])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["settlement_cost"]["lease"][3])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["settlement_cost"]["lease"][4])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["settlement_cost"]["lease"][5])
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [
                          _c("b", [_vm._v("C19 " + _vm._s(_vm.letter))]),
                          _vm._v(" SCALE cost")
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v("£" + _vm._s(new_cost["scale_cost"]) + " ")
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(9, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["scale_service"]["purchase"]) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L7")]),
                          _vm._v(
                            " £" + _vm._s(new_cost["scale_service"]["lease"][0])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L8")]),
                          _vm._v(
                            " £" + _vm._s(new_cost["scale_service"]["lease"][1])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L9")]),
                          _vm._v(
                            " £" + _vm._s(new_cost["scale_service"]["lease"][2])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L10")]),
                          _vm._v(
                            " £" + _vm._s(new_cost["scale_service"]["lease"][3])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L11")]),
                          _vm._v(
                            " £" + _vm._s(new_cost["scale_service"]["lease"][4])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L12")]),
                          _vm._v(
                            " £" + _vm._s(new_cost["scale_service"]["lease"][5])
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [_vm._v("Annual incremental SCALE SERVICE")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_scale_service"][
                                  "purchase"
                                ]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_scale_service"][
                                  "lease"
                                ][0]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_scale_service"][
                                  "lease"
                                ][1]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_scale_service"][
                                  "lease"
                                ][2]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_scale_service"][
                                  "lease"
                                ][3]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_scale_service"][
                                  "lease"
                                ][4]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_scale_service"][
                                  "lease"
                                ][5]
                              )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(10, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" + _vm._s(new_cost["upgraded_scale_cost"]) + " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(11, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["upgraded_scale_service"]) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(12, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["differential_weighing"]) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(13, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["departmental_accounting"]) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(14, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["engineer_installation"]) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(15, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["logo_and_return_address"]) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(16, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["business_mail_advanced"]) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(17, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["connectivity_kit_cost"]) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(18, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["connectivity_kit_service_cost"][
                                  "purchase"
                                ]
                              ) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L13")]),
                          _vm._v(
                            " £" +
                              _vm._s(
                                new_cost["connectivity_kit_service_cost"][
                                  "lease"
                                ][0]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L14")]),
                          _vm._v(
                            " £" +
                              _vm._s(
                                new_cost["connectivity_kit_service_cost"][
                                  "lease"
                                ][1]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L15")]),
                          _vm._v(
                            " £" +
                              _vm._s(
                                new_cost["connectivity_kit_service_cost"][
                                  "lease"
                                ][2]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L16")]),
                          _vm._v(
                            " £" +
                              _vm._s(
                                new_cost["connectivity_kit_service_cost"][
                                  "lease"
                                ][3]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L17")]),
                          _vm._v(
                            " £" +
                              _vm._s(
                                new_cost["connectivity_kit_service_cost"][
                                  "lease"
                                ][4]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L18")]),
                          _vm._v(
                            " £" +
                              _vm._s(
                                new_cost["connectivity_kit_service_cost"][
                                  "lease"
                                ][5]
                              )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [
                          _vm._v(
                            "Annual incremental connectivity kit service cost"
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost[
                                  "annual_incremental_connectivity_kit_service_cost"
                                ]["purchase"]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost[
                                  "annual_incremental_connectivity_kit_service_cost"
                                ]["lease"][0]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost[
                                  "annual_incremental_connectivity_kit_service_cost"
                                ]["lease"][1]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost[
                                  "annual_incremental_connectivity_kit_service_cost"
                                ]["lease"][2]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost[
                                  "annual_incremental_connectivity_kit_service_cost"
                                ]["lease"][3]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost[
                                  "annual_incremental_connectivity_kit_service_cost"
                                ]["lease"][4]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost[
                                  "annual_incremental_connectivity_kit_service_cost"
                                ]["lease"][5]
                              )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(19, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["inbound_courier_parcel_tracking_cost"]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(20, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost[
                                  "inbound_courier_parcel_tracking_service_cost"
                                ]["purchase"]
                              ) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L19")]),
                          _vm._v(
                            " £" +
                              _vm._s(
                                new_cost[
                                  "inbound_courier_parcel_tracking_service_cost"
                                ]["lease"][0]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L20")]),
                          _vm._v(
                            " £" +
                              _vm._s(
                                new_cost[
                                  "inbound_courier_parcel_tracking_service_cost"
                                ]["lease"][1]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L21")]),
                          _vm._v(
                            " £" +
                              _vm._s(
                                new_cost[
                                  "inbound_courier_parcel_tracking_service_cost"
                                ]["lease"][2]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L22")]),
                          _vm._v(
                            " £" +
                              _vm._s(
                                new_cost[
                                  "inbound_courier_parcel_tracking_service_cost"
                                ]["lease"][3]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L23")]),
                          _vm._v(
                            " £" +
                              _vm._s(
                                new_cost[
                                  "inbound_courier_parcel_tracking_service_cost"
                                ]["lease"][4]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L24")]),
                          _vm._v(
                            " £" +
                              _vm._s(
                                new_cost[
                                  "inbound_courier_parcel_tracking_service_cost"
                                ]["lease"][5]
                              )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [
                          _vm._v(
                            "Annual incremental inbound courier/parcel tracking service cost"
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost[
                                  "annual_incremental_inbound_courier_parcel_tracking_service_cost"
                                ]["purchase"]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost[
                                  "annual_incremental_inbound_courier_parcel_tracking_service_cost"
                                ]["lease"][0]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost[
                                  "annual_incremental_inbound_courier_parcel_tracking_service_cost"
                                ]["lease"][1]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost[
                                  "annual_incremental_inbound_courier_parcel_tracking_service_cost"
                                ]["lease"][2]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost[
                                  "annual_incremental_inbound_courier_parcel_tracking_service_cost"
                                ]["lease"][3]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost[
                                  "annual_incremental_inbound_courier_parcel_tracking_service_cost"
                                ]["lease"][4]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost[
                                  "annual_incremental_inbound_courier_parcel_tracking_service_cost"
                                ]["lease"][5]
                              )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(21, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["outbound_shipping_application"]
                              ) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(22, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["service_upgrade"]["purchase"]) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L25")]),
                          _vm._v(
                            " £" +
                              _vm._s(new_cost["service_upgrade"]["lease"][0])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L26")]),
                          _vm._v(
                            " £" +
                              _vm._s(new_cost["service_upgrade"]["lease"][1])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L27")]),
                          _vm._v(
                            " £" +
                              _vm._s(new_cost["service_upgrade"]["lease"][2])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L28")]),
                          _vm._v(
                            " £" +
                              _vm._s(new_cost["service_upgrade"]["lease"][3])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L29")]),
                          _vm._v(
                            " £" +
                              _vm._s(new_cost["service_upgrade"]["lease"][4])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("L30")]),
                          _vm._v(
                            " £" +
                              _vm._s(new_cost["service_upgrade"]["lease"][5])
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [
                          _vm._v("Annual incremental Service Upgrade")
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_service_upgrade"][
                                  "purchase"
                                ]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_service_upgrade"][
                                  "lease"
                                ][0]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_service_upgrade"][
                                  "lease"
                                ][1]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_service_upgrade"][
                                  "lease"
                                ][2]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_service_upgrade"][
                                  "lease"
                                ][3]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_service_upgrade"][
                                  "lease"
                                ][4]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["annual_incremental_service_upgrade"][
                                  "lease"
                                ][5]
                              )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(23, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v("£" + _vm._s(new_cost["consumables_ink_cost"]))
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(24, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" + _vm._s(new_cost["consumable_label_cost"])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(25, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" + _vm._s(new_cost["postage_recredit_costs"])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(26, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v("£" + _vm._s(new_cost["postage_savings"]))
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(27, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v("£" + _vm._s(new_cost["lease_setup_fee"]))
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(28, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["lease_annual_admin_fee"]["purchase"]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["lease_annual_admin_fee"]["lease"][0]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["lease_annual_admin_fee"]["lease"][1]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["lease_annual_admin_fee"]["lease"][2]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["lease_annual_admin_fee"]["lease"][3]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["lease_annual_admin_fee"]["lease"][4]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["lease_annual_admin_fee"]["lease"][5]
                              )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(29, true),
                        _vm._v(" "),
                        _c("td", [_vm._v("£" + _vm._s(new_cost["margin"]))]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(30, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v("£" + _vm._s(new_cost["promotional_saving_1"]))
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(31, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v("£" + _vm._s(new_cost["promotional_saving_2"]))
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(32, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v("£" + _vm._s(new_cost["lease_adhoc_costs"]))
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(33, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v("£" + _vm._s(new_cost["total_of_adhoc_costs"]))
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(34, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["total_equipment_cost"]["purchase"]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["total_equipment_cost"]["lease"][0]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["total_equipment_cost"]["lease"][1]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["total_equipment_cost"]["lease"][2]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["total_equipment_cost"]["lease"][3]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["total_equipment_cost"]["lease"][4]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["total_equipment_cost"]["lease"][5]
                              )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(35, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["total_service_cost"]["purchase"])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["total_service_cost"]["lease"][0])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["total_service_cost"]["lease"][1])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["total_service_cost"]["lease"][2])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["total_service_cost"]["lease"][3])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["total_service_cost"]["lease"][4])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(new_cost["total_service_cost"]["lease"][5])
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(36, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["total_savings_over_term"]["purchase"]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["total_savings_over_term"]["lease"][0]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["total_savings_over_term"]["lease"][1]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["total_savings_over_term"]["lease"][2]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["total_savings_over_term"]["lease"][3]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["total_savings_over_term"]["lease"][4]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["total_savings_over_term"]["lease"][5]
                              )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(37, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["effective_annual_saving"]["purchase"]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["effective_annual_saving"]["lease"][0]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["effective_annual_saving"]["lease"][1]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["effective_annual_saving"]["lease"][2]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["effective_annual_saving"]["lease"][3]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["effective_annual_saving"]["lease"][4]
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "£" +
                              _vm._s(
                                new_cost["effective_annual_saving"]["lease"][5]
                              )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(38, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["total_effective_cost"]["purchase"])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["total_effective_cost"]["lease"][0])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["total_effective_cost"]["lease"][1])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["total_effective_cost"]["lease"][2])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["total_effective_cost"]["lease"][3])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["total_effective_cost"]["lease"][4])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["total_effective_cost"]["lease"][5])
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(39, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["switch_and_save"]["purchase"])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["switch_and_save"]["lease"][0])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["switch_and_save"]["lease"][1])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["switch_and_save"]["lease"][2])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["switch_and_save"]["lease"][3])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["switch_and_save"]["lease"][4])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["switch_and_save"]["lease"][5])
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(40, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["saving_over_term"]["purchase"])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["saving_over_term"]["lease"][0])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["saving_over_term"]["lease"][1])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["saving_over_term"]["lease"][2])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["saving_over_term"]["lease"][3])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["saving_over_term"]["lease"][4])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["saving_over_term"]["lease"][5])
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(41, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["total_equipment_and_service_cost"][
                                "purchase"
                              ]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["total_equipment_and_service_cost"][
                                "lease"
                              ][0]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["total_equipment_and_service_cost"][
                                "lease"
                              ][1]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["total_equipment_and_service_cost"][
                                "lease"
                              ][2]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["total_equipment_and_service_cost"][
                                "lease"
                              ][3]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["total_equipment_and_service_cost"][
                                "lease"
                              ][4]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["total_equipment_and_service_cost"][
                                "lease"
                              ][5]
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(42, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.current_costs["total_current_cost_per_annum"]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(43, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["annual_savings_available"]["purchase"]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["annual_savings_available"]["lease"][0]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["annual_savings_available"]["lease"][1]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["annual_savings_available"]["lease"][2]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["annual_savings_available"]["lease"][3]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["annual_savings_available"]["lease"][4]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["annual_savings_available"]["lease"][5]
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(44, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["savings_over_term"]["purchase"])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["savings_over_term"]["lease"][0])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["savings_over_term"]["lease"][1])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["savings_over_term"]["lease"][2])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["savings_over_term"]["lease"][3])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["savings_over_term"]["lease"][4])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(new_cost["savings_over_term"]["lease"][5])
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(45, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["postage_savings_over_term"]["purchase"]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["postage_savings_over_term"]["lease"][0]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["postage_savings_over_term"]["lease"][1]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["postage_savings_over_term"]["lease"][2]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["postage_savings_over_term"]["lease"][3]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["postage_savings_over_term"]["lease"][4]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["postage_savings_over_term"]["lease"][5]
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(46, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(new_cost["tme_consumable_ink_costs"]))
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(47, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(new_cost["tme_consumable_label_costs"]))
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(48, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["saving_vs_current_rental_and_service"][
                                "purchase"
                              ]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["saving_vs_current_rental_and_service"][
                                "lease"
                              ][0]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["saving_vs_current_rental_and_service"][
                                "lease"
                              ][1]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["saving_vs_current_rental_and_service"][
                                "lease"
                              ][2]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["saving_vs_current_rental_and_service"][
                                "lease"
                              ][3]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["saving_vs_current_rental_and_service"][
                                "lease"
                              ][4]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["saving_vs_current_rental_and_service"][
                                "lease"
                              ][5]
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(49, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(new_cost["saving_vs_current_ink"]))
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(50, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(new_cost["saving_vs_current_labels"]))
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(51, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["saving_vs_current_postage_recredits"]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "6" } })
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(52, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["new_ink_label_postage_top_up"][
                                "purchase"
                              ]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["new_ink_label_postage_top_up"][
                                "lease"
                              ][0]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["new_ink_label_postage_top_up"][
                                "lease"
                              ][1]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["new_ink_label_postage_top_up"][
                                "lease"
                              ][2]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["new_ink_label_postage_top_up"][
                                "lease"
                              ][3]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["new_ink_label_postage_top_up"][
                                "lease"
                              ][4]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["new_ink_label_postage_top_up"][
                                "lease"
                              ][5]
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(53, true),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["total_cost_future_ownership"][
                                "purchase"
                              ]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["total_cost_future_ownership"][
                                "lease"
                              ][0]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["total_cost_future_ownership"][
                                "lease"
                              ][1]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["total_cost_future_ownership"][
                                "lease"
                              ][2]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["total_cost_future_ownership"][
                                "lease"
                              ][3]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["total_cost_future_ownership"][
                                "lease"
                              ][4]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              new_cost["total_cost_future_ownership"][
                                "lease"
                              ][5]
                            )
                          )
                        ])
                      ])
                    ]
                  )
                ]
              )
            }),
            0
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Purchase")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("1")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("2")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("3")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("4")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("5")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("6")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C17")]), _vm._v(" Service Cost")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C18")]), _vm._v(" Settlement cost")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C20")]), _vm._v(" SCALE SERVICE")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C21")]), _vm._v(" Upgrade scale cost")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C22")]),
      _vm._v(" upgraded scale service")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C23")]),
      _vm._v(" DIFFERENTIAL WEIGHING")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C24")]),
      _vm._v(" Departmental accounting")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C25")]),
      _vm._v(" ENGINEER INSTALLATION")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C26")]),
      _vm._v(" Logo and return address")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C27")]),
      _vm._v(" business mail advanced")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C28")]),
      _vm._v(" connectivity kit cost")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C29")]),
      _vm._v(" connectivity kit service cost")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C30")]),
      _vm._v(" inbound courier/parcel tracking cost")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C31")]),
      _vm._v(" inbound courier/parcel tracking service cost")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C32")]),
      _vm._v(" outbound shipping application")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C33")]), _vm._v(" Service Upgrade")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C34")]), _vm._v(" Consumables ink cost")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C35")]),
      _vm._v(" Consumable label cost")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C36")]),
      _vm._v(" Postage Recredit costs")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C37")]), _vm._v(" Postage Savings")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C38")]), _vm._v(" Lease Setup fee")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C39")]),
      _vm._v(" Lease Annual admin fee")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C40")]), _vm._v(" MARGIN")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C41")]), _vm._v(" PROMOTIONAL SAVING 1")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C42")]), _vm._v(" PROMOTIONAL SAVING 2")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C43")]), _vm._v(" Lease adhoc costs")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C44")]), _vm._v(" Total of adhoc costs")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C45")]),
      _vm._v(" Total Equipment cost ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C46")]), _vm._v(" Total Service cost ")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C47")]),
      _vm._v(" Total Savings Over Term (Calculated on 5 years if purchased) ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C48")]),
      _vm._v(" Effective Annual Saving ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C49")]), _vm._v(" Total effective cost")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C50")]), _vm._v(" Switch and save")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C51")]), _vm._v(" Saving over term")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C52")]),
      _vm._v(" Total equipment and service cost")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C53")]),
      _vm._v(" Total current cost per annum")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C54")]),
      _vm._v(" Annual savings available")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("C55")]), _vm._v(" Savings over term")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C56")]),
      _vm._v(" Postage savings over term")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C57")]),
      _vm._v(" TME consumable ink cost")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C58")]),
      _vm._v(" TME consumable label cost")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C59")]),
      _vm._v(" Saving vs current rental and service")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C60")]),
      _vm._v(" Saving vs current ink")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C61")]),
      _vm._v(" Saving vs current labels")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C62")]),
      _vm._v(" Saving vs current postage recredits")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C63")]),
      _vm._v(" New ink, label and postage top up cost")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("C64")]),
      _vm._v(" Total cost of future ownership")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17742f29", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17742f29","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Debug/QuoteInfo/MachineLeaseTerms.vue
// module id = null
// module chunks = 